import type { ReactNode } from 'react'
import { useState } from 'react'

import classNames from '../../utils/classNames'

interface AccordionProps {
  label: string
  children: ReactNode
  defaultOpen?: boolean
}

const Accordion = ({
  label,
  children,
  defaultOpen = false,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div>
      <button
        type="button"
        className="flex items-center gap-1 text-secondary-txt text-sm xl:text-base mb-1"
        onClick={() => setIsOpen(prev => !prev)}>
        {label}
        <svg
          className={classNames(
            'w-4 h-4 transition-transform duration-200',
            isOpen && 'rotate-180',
          )}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      <div
        className={classNames(
          'grid transition-all duration-200',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        )}>
        <div className="overflow-hidden">{children}</div>
      </div>
    </div>
  )
}

export default Accordion
